import { put, takeLatest } from 'redux-saga/effects'
import { Action } from 'redux'
import { rootActions } from '@app-store/slices'
import axios, { getParams } from '@utils/request'
import { IListHallPayload } from '@app-store/slices/hall/list'

interface TaskAction extends Action {
    payload: IListHallPayload
}

const { onRequest, onSuccess, onFailure } = rootActions.hall.list

function* listHallSagaTask({ payload }) {
    const params = yield getParams(payload)

    try {
        const response = yield axios.get(`/meeting/hall`, {
            params
        })
        if (response.success) {
            yield put(onSuccess(response.result))
            if (payload?.sagaCB) {
                payload?.sagaCB?.onSuccess(response.result)
            }
        } else {
            throw new Error('')
        }
    } catch (error) {
        yield put(onFailure(error))
    }
}

function* listHallSaga(): any {
    yield takeLatest<TaskAction>(onRequest, listHallSagaTask)
}

export default listHallSaga
